import React from 'react';
import {Dialog, DialogActions, Button, Box, Typography, DialogContent} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const AlertDialog = ({isOpen, closeDialog, dialogText}) => {
    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            closeDialog();
        }
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="md">
            <DialogContent sx={{
                paddingBottom: 0,
                marginBottom: 0
            }}>
                <Box display="flex" alignItems="center" justifyContent="center">
                    <WarningIcon color="warning" sx={{mr: 1}}/>
                    <Typography variant="h6" align="center">
                        {dialogText}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{
                padding: 0,
                margin: 0
            }}>
                <Button onClick={closeDialog} color="primary" sx={{margin: 0}}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;
